// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filtersLayoutStyles } from "@sc/App/Widgets/OrderHistory/OrderHistoryFiltersLayout";
import { DivWrapper } from "@sc/XDL/constants";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

filtersLayoutStyles.container = {
    css: css`
        padding: 12px;
        ${xScreen("lte", "md")} {
            padding: 0;
        }
        & > ${DivWrapper} {
            display: flex;
            column-gap: 12px;
            row-gap: 16px;
            flex-wrap: wrap;
            align-items: flex-end;

            margin-left: auto;
            ${xScreen("lte", "xs")} {
                & > div:last-child {
                    margin-left: initial;
                    width: 100%;
                }
            }

            & > div:last-child {
                width: 100%;
                margin-left: auto;
                justify-content: flex-end;
                align-items: end;

                & > div:first-child {
                    flex-grow: 1;
                }
            }
        }
    `,
};
